module.exports = __webpack_public_path__ + "img/c01_unithoplite_Normal_ua.4adf3d36.webp";